import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

// import SvgIcon from "@mui/material/SvgIcon";
import Grow from '@mui/material/Grow';
import Popper from '@mui/material/Popper';
// import Button from "@mui/material/Button";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";

// import {setLookIntroStep, setLookOverlayOpened} from "../../../../actions/lookFunctions";
// import {setLocalStorageItem} from "../lookFunctions";
// import {LOOK_INTRO_STEPS} from "../../core/constants";
// import {LookIconNavigate} from "../../../common/icons";

const LookIntroPopper = (props) => {

  const {introStep, anchorRef, currentStep, placement, toolTipText = "", className} = props;

  // const nextButtonClick = () => {
  //   if (currentStep === LOOK_INTRO_STEPS.review) {
  //     setLookIntroStep(introStep + 2); // go to exit, skip rooms
  //   } else if (currentStep === LOOK_INTRO_STEPS.exit) { // exit button - finish
  //     setLookOverlayOpened("");
  //     setLookIntroStep(LOOK_INTRO_STEPS.disabled);
  //     setLocalStorageItem(LOCAL_STORAGE_KEYS.introVisited, true);
  //   } else {
  //     setLookIntroStep(introStep + 1);
  //   }
  // };

  return (
    <Popper open={introStep === currentStep}
            className={"look-step look-step--" + currentStep + " look-step--" + placement + (className ? " " + className : "")}
            anchorEl={anchorRef.current}
            placement={placement}
            transition
            disablePortal>
      {({ TransitionProps }) => (
        <Grow
          {...TransitionProps}
          style={{ transformOrigin: placement === "right" ? "right center" : "left center" }}
        >
          <div className="look-step__content">
            <span className={"look-step__content-text look-step__content-text--" + placement}>
              {/*<SvgIcon>*/}
              {/*  <LookIconNavigate/>*/}
              {/*</SvgIcon>*/}
              <FormattedMessage id={toolTipText || "look.intro.step" + currentStep + ".tooltip"}/>
            </span>
            {/*{lastMobileSteps ? null : (*/}
            {/*  <Button className={"look-button look-button--white"}*/}
            {/*          endIcon={<ChevronRightIcon />}*/}
            {/*          onClick={nextButtonClick}>*/}
            {/*    <FormattedMessage id={currentStep === LOOK_INTRO_STEPS.exit ? "buttons.start" : "buttons.next"}/>*/}
            {/*  </Button>*/}
            {/*)}*/}
          </div>
        </Grow>
      )}
    </Popper>
  )
};

LookIntroPopper.propTypes = {
  // anchorRef: PropTypes.oneOfType([
  //   PropTypes.func,
  //   PropTypes.shape({ current: PropTypes.elementType })
  // ]).isRequired,
  anchorRef: PropTypes.object.isRequired,
  currentStep: PropTypes.number.isRequired,
  placement: PropTypes.string,
  toolTipText: PropTypes.string,
  className: PropTypes.string,
}

LookIntroPopper.defaultProps = {
  placement: "right"
}

const mapStateToProps = (store) => {
  const {introStep} = store.lookState;
  // const {isMobile} = store.serverState;
  return {
    introStep,
    // isMobile,
  };
};

const mapDispatchToProps = {
  // setLookIntroStep,
  // setLookOverlayOpened,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookIntroPopper)
